(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('RuoloFunzione', RuoloFunzione);

    RuoloFunzione.$inject = ['$resource'];

    function RuoloFunzione ($resource) {
        var resourceUrl =  'api/ruolo-funziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
